const VERSION: string = '0.1.7-prod.8'
export default VERSION;
